module.exports = __webpack_public_path__ + "static/media/pic100.b27bced2.JPG";